import { render, staticRenderFns } from "./NewEnergy.vue?vue&type=template&id=657372c8&"
import script from "./NewEnergy.vue?vue&type=script&lang=js&"
export * from "./NewEnergy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports